import React from 'react';
import Swiper from 'react-id-swiper';
// import Swiper from 'react-id-swiper';

class AwoolPlanet extends React.Component {
  render() {
    const params = {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      spaceBetween: 10,
      slidesPerView: 4.2,
      freeMode: true,
    }
    return (
      <div className="content awool theme-drdiary">
        <div className="keywords">
          <p className="content-title"><span>k</span>eywords</p>
          <div className="content-article">
            <div className="keywords__row"><p className="keywords__label">Position</p><p className="keywords__value">CTO · Senior Full-stack Engineer</p></div>
            <div className="keywords__row"><p className="keywords__label">Skills</p><p className="keywords__value">Node.js · Express · MongoDB · React · Firebase · AWS</p></div>
            <div className="keywords__row"><p className="keywords__label">Focus</p><p className="keywords__value">Startup Growth (11 → 130) · Server Architecture · CI/CD · Data Dashboards</p></div>
          </div>
        </div>
        <p className="content-title"><span>a</span>bstract</p>
        <div className="content-article content-article-paragraphs">
          <p>
            Dr. Diary was selected for Forbes Asia's 30 Under 30 in 2020. Dr. Diary is a total solution platform 
            for diabetes, connecting users and insurance companies, from blood sugar tracking to diet management and insurance.
          </p>
          <p>Our slogan is "Taking care of diabetes conveniently, We prepare everything about diabetes for you."</p>
          <p>
            I joined Dr. Diary as a Senior Full-stack Engineer when the company had 11 employees, and was later 
            promoted to CTO. I contributed to a wide range of projects as the company grew to 130 employees.
          </p>
        </div>
        <div className="content-article">
          <Swiper className="swiper" {...params}>
            <div className="slide">
              <div><img className="slide-img" src={require('./../images/drdiary_01.png')} alt={'Dr. Diary Screen'} /></div>
            </div>
            <div className="slide">
              <div><img className="slide-img" src={require('./../images/drdiary_02.png')} alt={'Dr. Diary Screen'} /></div>
            </div>
            <div className="slide">
              <div><img className="slide-img" src={require('./../images/drdiary_03.png')} alt={'Dr. Diary Screen'} /></div>
            </div>
            <div className="slide">
              <div><img className="slide-img" src={require('./../images/drdiary_04.png')} alt={'Dr. Diary Screen'} /></div>
            </div>
            <div className="slide">
              <div><img className="slide-img" src={require('./../images/drdiary_05.png')} alt={'Dr. Diary Screen'} /></div>
            </div>
          </Swiper>
        </div>
        <p className="content-title"><span>E</span>xperience</p>
        <div className="content-article content-article-list">
          <p>• Led and scaled the engineering team from 3 to 11 engineers as the company grew from 11 to 130 employees, owning technical strategy and architecture</p>
          <p>• Designed and implemented a scalable server infrastructure on AWS</p>
          <p>• Developed APIs for the Dr. Diary app using Node.js (Express)</p>
          <p>• Architected and led end-to-end development of the CMS using the MERN stack</p>
          <p>• Built a user behavior logging system using MongoDB and Firebase to capture in-app activity data</p>
          <p>• Developed data visualization dashboards to analyze user behavior and drive product strategy for improving user retention</p>
          <p>• Owned the CI/CD pipeline end to end, from server operations to deployment and release verification</p>
        </div>
        <p className="content-title"><span>p</span>rojects</p>
        <div className="content-article content-article-list">
          <p>• Dr. Diary Blood Glucose Meter Subscription System Development</p>
          <p>• Dr. Diary Mall E-commerce Maintanance </p>
          <p>• Dr. Diary App v2 Server Side Development </p>
          <p>• Dr. Diary Admin System Maintanance </p>
        </div>
        <p className="content-title"><span>a</span>chivement</p>
        <div className="content-article content-article-list content-final">
          <p>• Learning great qualities of leadership </p>
          <p>• <img className="drdiary-img-icon" src={require('./../images/drdiary_checked.png')} alt={'AWS Certification Mark'} /> AWS Certified Solutions Architect - Associate</p>
          <p>• Handling with massive traffic</p>
          <p>• Implemented reliable and scalable server architecture</p>
          <p>• Optimized MongoDB with Performance Advisor & Profiler, etc.</p>
        </div>
      </div>
      
    );
  }
}

export default AwoolPlanet;
